export default __webpack_public_path__ + "static/media/Visacard.80ef9e42.svg";